import { render, staticRenderFns } from "./SearchNavHeader.vue?vue&type=template&id=13521626&scoped=true&"
import script from "./SearchNavHeader.vue?vue&type=script&lang=js&"
export * from "./SearchNavHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13521626",
  null
  
)

export default component.exports